import script from "./ChatSavedThreads.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSavedThreads.vue?vue&type=script&setup=true&lang=js"

import "./ChatSavedThreads.vue?vue&type=style&index=0&id=b1ea97d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1ea97d6"]])

export default __exports__